export default "__VITE_ASSET__6je8VftQ__ 409w";